import React from 'react';
import PropTypes from 'prop-types';
import { feathersCreateData, feathersFindDataAll } from '../../services';
import { useEffect, useState } from 'react';
import CheckPayrollComponent from './CheckPayrollComponent';
import { startOfMonth } from 'date-fns';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import ShowValidatorsActivities from '../../components/Payrolls/ShowValidatorsActivities';
import ShowPayrollVouchers from '../../components/Payrolls/ShowPayrollVouchers';
import LoadingScreen from '../../components/Complements/LoadingScreen';
import client from '../../services/feathers';
// import { urlVoucher } from '../../services/urls';
// import { sendMobile } from '../../functions/mobile';
import { useSelector } from 'react-redux';
// import { history } from '../../helpers/history';
import { consolidateReportPDF } from '../../components/Payrolls/functions/consolidate-report';

const CheckPayrollContainer = ({ handleLogOut, setLoading, handleOpenSnack }) => {
  const user = useSelector((state) => state.authentication.user);
  // const navigate = useNavigate();
  const [accountList, setAccountList] = useState([]);
  const [startDate, setStartDate] = useState(startOfMonth(new Date()));
  const [endDate, setEndDate] = useState(new Date());
  const [dataJson, setDataJson] = useState([]);
  const [dataValidators, setDataValidators] = useState([]);
  const [dataTransactions, setDataTransactions] = useState([]);
  // eslint-disable-next-line
  const [rowSelected, setRowSelected] = useState({});
  const [showValidators, setShowValidators] = useState(false);
  const [showTransactions, setShowTransactions] = useState(false);
  // const [enabledDownloadConsolidate, setEnabledDownloadConsolidate] = useState(true);
  const [processPercent, setProcessPercent] = useState(0);

  const getAccounts = async () => {
    try {
      const getAccountsData = await feathersCreateData('core-server', {
        service: 'ACCOUNT',
        func: 'RETURN CONSOLIDATED ACCOUNTS',
        data: { Identificacion: user.vusk },
      }, setLoading)();
      if (
        getAccountsData.error === undefined ||
        getAccountsData.error !== false
      ) {
        //show message error
        return;
      }

      setAccountList(getAccountsData.data || []);
      handleGetActivities(getAccountsData.data.length > 0 ? getAccountsData.data[0].PRODUCTBANKID : 0);

    } catch (e) {
      console.log(e);
    }
  };
  CheckPayrollContainer.propTypes = {
    handleLogOut: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
  };

  useEffect(() => {
    getAccounts();
    socketActivity();
    // console.log(user);
    // eslint-disable-next-line
  }, []);

  const socketActivity = () => {
    client.service('activity-indicator').on('patched', activity => {
      console.log("🚀 ~ client.service ~ activity:", activity, user)
      const { company: companyActivity, process, percent, state: stateActivity, account } = activity
      if (companyActivity === user.company && process === 'PAYROLL_PAYMENT') {
        setProcessPercent(percent)
        console.log(stateActivity, process)
        if (stateActivity === 2) {
          handleGetActivities(account)
        }
      }
    })
  }

  const handleGetActivities = (selectedAccount) => {
    try {
      feathersCreateData('payrolls-control', {
        service: 'GET_ACTIVITIES_PAYROLL', data: {
          startDate, endDate, selectedAccount
        }
      })()
        .then(res => {
          // console.log(res);

          const { error, type } = res
          if (error) {
            handleOpenSnack(res.message, type);
            // navigate('/home');
            // history.push('/')
          } else {
            const { payrollTray } = res.data
            setDataJson(payrollTray)
            // handleOpenSnack(res.message, 'success');
          }
          setLoading(false);
        }).catch(err => {
          setLoading(false);
        })
    } catch (error) {
    }
  }

  const getValidators = (row) => {
    try {
      const { id } = row
      feathersFindDataAll('payrolls-validate', { payroll: id })()
        .then(res => {
          // console.log(res);

          const { error } = res
          if (error) {
            handleOpenSnack(res.message, 'error');
          } else {
            setDataValidators(res)
            setShowValidators(true)
          }
          setLoading(false);
        }).catch(err => {
          setLoading(false);
        })
    } catch (error) {
    }
  }
  const getTransactions = (row) => {
    try {
      const { id } = row
      feathersFindDataAll('payrolls-tray', { id })()
        .then(res => {
          if (res.length <= 0) {
            handleOpenSnack(res.message, 'error');
          } else {
            setRowSelected(row)
            setDataTransactions(res[0].body)
            setShowTransactions(true)
          }
          setLoading(false);
        }).catch(err => {
          setLoading(false);
        })
    } catch (error) {
    }
  }

  // const handleDownloadVoucherPayroll = (nameFile) => {
  //   if (localStorage.oct_app !== undefined) {
  //     sendMobile(JSON.stringify({
  //       type: 'openLink',
  //       data: urlVoucher + nameFile + ".pdf"
  //     }))
  //   } else {
  //     window.open(urlVoucher + nameFile + ".pdf", '_blank');
  //   }
  // }


  return (
    <>
      {
        accountList.length > 0 &&
        <CheckPayrollComponent
          accountList={accountList}
          processPercent={processPercent}
          handleLogOut={handleLogOut}
          handleOpenSnack={handleOpenSnack}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          handleFindActivity={handleGetActivities}
          dataJson={dataJson}
          getValidators={getValidators}
          getTransactions={getTransactions}
        />
      }
      <LoadingScreen open={accountList.length === 0} />
      <Dialog
        fullScreen
        onClose={() => setShowValidators(false)}
        open={showValidators}>
        <DialogContent>
          <ShowValidatorsActivities dataValidators={dataValidators} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setShowValidators(false)} style={{
            backgroundColor: '#B8992B',
            borderRadius: '8px',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#A38225',
            },
          }}>
            Salir
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen
        onClose={() => setShowTransactions(false)}
        open={showTransactions}>
        <DialogContent>
          <Button
            autoFocus
            variant="contained"
            color='primary'
            style={{ width: 'auto' }}
            onClick={() => consolidateReportPDF(dataTransactions, user.companies.name )}
            // disabled={!enabledDownloadConsolidate}
          >
            Descarga Consolidado
          </Button>
          <ShowPayrollVouchers dataTransactions={dataTransactions} />
        </DialogContent>
        <DialogActions>
          <Button color='secondary' variant='contained' autoFocus onClick={() => setShowTransactions(false)}>
            Salir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
CheckPayrollContainer.propTypes = {
  handleLogOut: PropTypes.func.isRequired,
};
export default CheckPayrollContainer;
